import { FundingPolicyType } from '@shared';

type SectionsObject = {
  [key: string]: PolicyFormSection;
};

export const healthDataSections: SectionsObject = {
  medicalHealthInfoFirstProposedInsured: {
    id: 'medical-health-info-fpi',
    title: 'Medical Questionnaire Part 2 - Health Information for "{clientFullName}"',
    subsections: [
      {
        id: 'physical-measurements-fpi',
        title: 'Physical Measurements',
        questionGroups: [
          {
            id: 'measurements-fpi',
            format: 'grid',
            questions: [
              'medicalFirstProposedInsuredHeightFT',
              'medicalFirstProposedInsuredHeightIN',
              'medicalFirstProposedInsuredWeight',
              'medicalFirstProposedInsuredWeightChange',
              'medicalFirstProposedInsuredWeightChangeAmount',
            ],
          },
        ],
      },
      {
        id: 'medical-conditions-a-fpi-part-1',
        title: 'Medical History - During Past 10 Years',
        questionGroups: [
          {
            id: 'medical-conditions-a-fpi-group-1',
            format: 'default',
            questions: [
              'medicalHeartAttackFirstInsured',
              'medicalHighBloodPressureFirstInsured',
              'medicalStrokeFirstInsured',
              'medicalTransientIschemicAttackTiaFirstInsured',
              'medicalCongestiveHeartFailureFirstInsured',
              'medicalIrregularHeartbeatFirstInsured',
              'medicalAneurysmFirstInsured',
              'medicalCarotidArteryDiseaseFirstInsured',
              'medicalCardiomyopathyFirstInsured',
              'medicalHeartMurmurFirstInsured',
              'medicalCoronaryArteryDiseaseFirstInsured',
              'medicalAtrialFibrillationFirstInsured',
              'medicalValvularHeartDiseaseFirstInsured',
              'medicalCongenitalHeartDiseaseFirstInsured',
              'medicalAtherosclerosisFirstInsured',
              'medicalPeripheralVascularDiseaseFirstInsured',
              'medicalVenousInsufficiencyFirstInsured',
              'medicalDeepVeinThrombosisFirstInsured',
              'medicalPulmonaryEmbolismFirstInsured',
              'medicalCancerFirstInsured',
              'medicalTumorFirstInsured',
              'medicalLymphomaFirstInsured',
              'medicalEnlargementOfTheLymphGlandFirstInsured',
              'medicalMultipleMyelomaFirstInsured',
              'medicalLeukemiaFirstInsured',
              'medicalAnemiaFirstInsured',
              'medicalPolycythemiaFirstInsured',
              'medicalThrombocytopeniaFirstInsured',
              'medicalDiabetesFirstInsured',
              'medicalChronicKidneyDiseaseFirstInsured',
              'medicalPolycysticKidneyDiseaseFirstInsured',
              'medicalKidneyFailureFirstInsured',
              'medicalNephritisFirstInsured',
              'medicalNephroticSyndromeFirstInsured',
              'medicalHematuriaFirstInsured',
              'medicalUrinaryIncontinenceFirstInsured',
              'medicalNeurogenicBladderFirstInsured',
              'medicalShortnessOfBreathFirstInsured',
              'medicalPulmonaryFibrosisFirstInsured',
              'medicalSarcoidosisFirstInsured',
              'medicalChronicObstructivePulmonaryDiseaseCopdFirstInsured',
              'medicalAsthmaFirstInsured',
              'medicalSleepApneaFirstInsured',
              'medicalEmphysemaFirstInsured',
              'medicalPneumoniaFirstInsured',
              'medicalTuberculosisFirstInsured',
              'medicalIntestinalBleedingFirstInsured',
              'medicalUlcerFirstInsured',
              'medicalHepatitisFirstInsured',
              'medicalGastroparesisFirstInsured',
              'medicalBarrettEsophagusFirstInsured',
              'medicalCrohnsDiseaseFirstInsured',
              'medicalUlcerativeColitisFirstInsured',
              'medicalCirrhosisFirstInsured',
              'medicalPancreatitisFirstInsured',
              'medicalLiverFailureFirstInsured',
              'medicalSchizophreniaFirstInsured',
              'medicalBipolarDisorderFirstInsured',
              'medicalDepressionFirstInsured',
              'medicalAnxietyFirstInsured',
              'medicalSuicideAttemptFirstInsured',
              'medicalAnorexiaFirstInsured',
              'medicalPostTraumaticStressDisorderFirstInsured',
              'medicalChronicFatigueFirstInsured',
              'medicalFibromyalgiaFirstInsured',
              'medicalDizzinessFirstInsured',
              'medicalVertigoFirstInsured',
              'medicalMigrainesFirstInsured',
              'medicalTraumaticBrainInjuryFirstInsured',
              'medicalGaitDisturbanceFirstInsured',
              'medicalNeurofibromatosisFirstInsured',
              'medicalFaintingFirstInsured',
              'medicalConvulsionsEpilepsyFirstInsured',
              'medicalParalysisFirstInsured',
              'medicalMyastheniaGravisFirstInsured',
              'medicalPeripheralNeuropathyFirstInsured',
              'medicalParkinsonDiseaseFirstInsured',
              'medicalMultipleSclerosisFirstInsured',
              'medicalALSFirstInsured',
              'medicalGuillainBarreSyndromeFirstInsured',
              'medicalAlzheimerDiseaseFirstInsured',
              'medicalDementiaFirstInsured',
              'medicalMemoryLossFirstInsured',
              'medicalCognitiveImpairmentFirstInsured',
              'medicalTremorsFirstInsured',
              'medicalArthritisFirstInsured',
              'medicalLossOfLimbFirstInsured',
              'medicalOrganTransplantFirstInsured',
              'medicalMyopathyFirstInsured',
              'medicalPolymyalgiaRheumaticaFirstInsured',
              'medicalMuscularDystrophyFirstInsured',
              'medicalVertebralFracturesFirstInsured',
              'medicalOsteoporosisFirstInsured',
              'medicalSystemicLupusFirstInsured',
              'medicalSclerodermaFirstInsured',
              'medicalRetinopathyFirstInsured',
              'medicalLossOfVisionFirstInsured',
              'medicalWetMacularDegenerationFirstInsured',
              'medicalKaposiSarcomaFirstInsured',
              'medicalPneumocystisCariniiPneumoniaFirstInsured',
            ],
          },
        ],
      },
      {
        id: 'medical-conditions-b-fpi-group-1',
        title: 'Medical History - During Past 2 Years',
        questionGroups: [
          {
            id: 'medical-conditions-b-fpi-group-1',
            format: 'default',
            questions: [
              'medicalHospitalTreatmentFirstInsured',
              'medicalEmergencyRoomTreatmentFirstInsured',
              'medicalNursingHomeAdmissionFirstInsured',
              'medicalNursingHomeRecommendationFirstInsured',
              'medicalAssistanceBathingFirstInsured',
              'medicalAssistanceDressingFirstInsured',
              'medicalAssistanceWalkingFirstInsured',
              'medicalAssistanceEatingFirstInsured',
              'medicalAssistanceUsingToiletFirstInsured',
              'medicalAssistanceGettingUpFirstInsured',
              'medicalAssistanceTakingMedicationFirstInsured',
              'medicalAssistanceShoppingFirstInsured',
              'medicalAssistanceCookingFirstInsured',
              'medicalPendingDiagnosticTestFirstInsured',
              'medicalPendingHospitalizationFirstInsured',
              'medicalPendingSurgeryFirstInsured',
              'medicalClaimInjuryFirstInsured',
              'medicalClaimSicknessFirstInsured',
              'medicalClaimDisabilityFirstInsured',
              'medicalInjuryFromFallFirstInsured',
            ],
          },
        ],
      },
      {
        id: 'medical-conditions-c-fpi-group-1',
        title: 'Current Medical Status',
        questionGroups: [
          {
            id: 'medical-conditions-c-fpi-group-1',
            format: 'default',
            questions: [
              'medicalPhysicalTherapyFirstInsured',
              'medicalOccupationalTherapyFirstInsured',
              'medicalSpeechTherapyFirstInsured',
              'medicalRespiratoryTherapyFirstInsured',
              'medicalCaneUseFirstInsured',
              'medicalCrutchUseFirstInsured',
              'medicalWalkerUseFirstInsured',
              'medicalWheelchairUseFirstInsured',
              'medicalMotorizedScooterUseFirstInsured',
              'medicalMotorizedChairUseFirstInsured',
              'medicalStairLiftUseFirstInsured',
              'medicalHandicappedPlacardUseFirstInsured',
              'medicalCatheterUseFirstInsured',
              'medicalOxygenEquipmentUseFirstInsured',
              'medicalRespiratorUseFirstInsured',
              'medicalCpapUseFirstInsured',
              'medicalDefibrillatorUseFirstInsured',
              'medicalPacemakerUseFirstInsured',
              'medicalDialysisUseFirstInsured',
              'medicalUpcomingVisitFirstInsured',
              'medicalCurrentlyPregnantFirstInsured',
              'medicalPrimaryCarePhysicianFirstInsuredName',
              'medicalPrimaryCarePhysicianFirstInsuredAddress',
              'medicalMedicationsFirstInsured',
            ],
          },
        ],
      },
      {
        id: 'other-medical-fpi',
        title: 'Medical Questionnaire - Other',
        questionGroups: [
          {
            id: 'driving-history-fpi',
            title: 'Driving and Legal History',
            format: 'default',
            questions: [
              'medicalDrivingViolationFirstInsured',
              'medicalCriminalConvictionFirstInsured',
            ],
          },
          {
            id: 'insurance-status-fpi',
            title: 'Insurance History',
            format: 'default',
            questions: [
              'medicalInsuranceDeclinedFirstInsured',
              'medicalSectionEDetailsFirstInsured',
            ],
          },
          {
            id: 'substance-history-fpi',
            title: 'Substance Use History',
            format: 'default',
            questions: [
              'medicalNarcoticsUseFirstInsured',
              'medicalBarbituratesUseFirstInsured',
              'medicalAmphetaminesUseFirstInsured',
              'medicalHallucinogensUseFirstInsured',
              'medicalHeroinUseFirstInsured',
              'medicalCocaineUseFirstInsured',
              'medicalMarijuanaUseFirstInsured',
              'medicalAlcoholTreatmentFirstInsured',
              'medicalPrescribedMedicationTreatmentFirstInsured',
              'medicalNonPrescribedDrugsTreatmentFirstInsured',
            ],
          },
          {
            id: 'hazardous-activities-fpi',
            title: 'Hazardous Activities',
            format: 'default',
            questions: [
              'medicalHazardousActivitiesFirstInsured',
              'medicalAviationFirstInsured',
              'medicalForeignTravelFirstInsured',
              'medicalArmedForcesFirstInsured',
            ],
          },
          {
            id: 'tobacco-nicotine-fpi',
            title: 'Tobacco or Nicotine Use',
            format: 'default',
            questions: [
              'nicotineCigarettesUseFirstInsured',
              'nicotinePipeUseFirstInsured',
              'nicotineCigarsUseFirstInsured',
              'nicotineSnuffUseFirstInsured',
              'nicotineChewingTobaccoUseFirstInsured',
              'nicotinePatchUseFirstInsured',
              'nicotineGumUseFirstInsured',
              'nicotineVapingUseFirstInsured',
              'nicotineECigarettesUseFirstInsured',
              'nicotineHookahUseFirstInsured',
            ],
          },
        ],
      },
    ],
  },
  medicalHealthInfoSecondProposedInsured: {
    id: 'medical-health-info-spi',
    title: 'Medical Questionnaire Part 2 - Health Information for "{clientPartnerFullName}"',
    conditional: {
      visible: {
        field: 'fundingPolicyType',
        operator: 'equals' as const,
        value: FundingPolicyType.jointAssetCare,
      },
    },
    subsections: [
      {
        id: 'physical-measurements-spi',
        title: 'Physical Measurements',
        questionGroups: [
          {
            id: 'measurements-spi',
            format: 'grid',
            questions: [
              'medicalSecondProposedInsuredHeightFT',
              'medicalSecondProposedInsuredHeightIN',
              'medicalSecondProposedInsuredWeight',
              'medicalSecondProposedInsuredWeightChange',
              'medicalSecondProposedInsuredWeightChangeAmount',
            ],
          },
        ],
      },
      {
        id: 'medical-conditions-a-spi-part-1',
        title: 'Medical History - During Past 10 Years',
        questionGroups: [
          {
            id: 'medical-conditions-a-spi-group-1',
            format: 'default',
            questions: [
              'medicalHeartAttackSecondInsured',
              'medicalHighBloodPressureSecondInsured',
              'medicalStrokeSecondInsured',
              'medicalTransientIschemicAttackTiaSecondInsured',
              'medicalCongestiveHeartFailureSecondInsured',
              'medicalIrregularHeartbeatSecondInsured',
              'medicalAneurysmSecondInsured',
              'medicalCarotidArteryDiseaseSecondInsured',
              'medicalCardiomyopathySecondInsured',
              'medicalHeartMurmurSecondInsured',
              'medicalCoronaryArteryDiseaseSecondInsured',
              'medicalAtrialFibrillationSecondInsured',
              'medicalValvularHeartDiseaseSecondInsured',
              'medicalCongenitalHeartDiseaseSecondInsured',
              'medicalAtherosclerosisSecondInsured',
              'medicalPeripheralVascularDiseaseSecondInsured',
              'medicalVenousInsufficiencySecondInsured',
              'medicalDeepVeinThrombosisSecondInsured',
              'medicalPulmonaryEmbolismSecondInsured',
              'medicalCancerSecondInsured',
              'medicalTumorSecondInsured',
              'medicalLymphomaSecondInsured',
              'medicalEnlargementOfTheLymphGlandSecondInsured',
              'medicalMultipleMyelomaSecondInsured',
              'medicalLeukemiaSecondInsured',
              'medicalAnemiaSecondInsured',
              'medicalPolycythemiaSecondInsured',
              'medicalThrombocytopeniaSecondInsured',
              'medicalDiabetesSecondInsured',
              'medicalChronicKidneyDiseaseSecondInsured',
              'medicalPolycysticKidneyDiseaseSecondInsured',
              'medicalKidneyFailureSecondInsured',
              'medicalNephritisSecondInsured',
              'medicalNephroticSyndromeSecondInsured',
              'medicalHematuriaSecondInsured',
              'medicalUrinaryIncontinenceSecondInsured',
              'medicalNeurogenicBladderSecondInsured',
              'medicalShortnessOfBreathSecondInsured',
              'medicalPulmonaryFibrosisSecondInsured',
              'medicalSarcoidosisSecondInsured',
              'medicalChronicObstructivePulmonaryDiseaseCopdSecondInsured',
              'medicalAsthmaSecondInsured',
              'medicalSleepApneaSecondInsured',
              'medicalEmphysemaSecondInsured',
              'medicalPneumoniaSecondInsured',
              'medicalTuberculosisSecondInsured',
              'medicalIntestinalBleedingSecondInsured',
              'medicalUlcerSecondInsured',
              'medicalHepatitisSecondInsured',
              'medicalGastroparesisSecondInsured',
              'medicalBarrettEsophagusSecondInsured',
              'medicalCrohnsDiseaseSecondInsured',
              'medicalUlcerativeColitisSecondInsured',
              'medicalCirrhosisSecondInsured',
              'medicalPancreatitisSecondInsured',
              'medicalLiverFailureSecondInsured',
              'medicalSchizophreniaSecondInsured',
              'medicalBipolarDisorderSecondInsured',
              'medicalDepressionSecondInsured',
              'medicalAnxietySecondInsured',
              'medicalSuicideAttemptSecondInsured',
              'medicalAnorexiaSecondInsured',
              'medicalPostTraumaticStressDisorderSecondInsured',
              'medicalChronicFatigueSecondInsured',
              'medicalFibromyalgiaSecondInsured',
              'medicalDizzinessSecondInsured',
              'medicalVertigoSecondInsured',
              'medicalMigrainesSecondInsured',
              'medicalTraumaticBrainInjurySecondInsured',
              'medicalGaitDisturbanceSecondInsured',
              'medicalNeurofibromatosisSecondInsured',
              'medicalFaintingSecondInsured',
              'medicalConvulsionsEpilepsySecondInsured',
              'medicalParalysisSecondInsured',
              'medicalMyastheniaGravisSecondInsured',
              'medicalPeripheralNeuropathySecondInsured',
              'medicalParkinsonDiseaseSecondInsured',
              'medicalMultipleSclerosisSecondInsured',
              'medicalALSSecondInsured',
              'medicalGuillainBarreSyndromeSecondInsured',
              'medicalAlzheimerDiseaseSecondInsured',
              'medicalDementiaSecondInsured',
              'medicalMemoryLossSecondInsured',
              'medicalCognitiveImpairmentSecondInsured',
              'medicalTremorsSecondInsured',
              'medicalArthritisSecondInsured',
              'medicalLossOfLimbSecondInsured',
              'medicalOrganTransplantSecondInsured',
              'medicalMyopathySecondInsured',
              'medicalPolymyalgiaRheumaticaSecondInsured',
              'medicalMuscularDystrophySecondInsured',
              'medicalVertebralFracturesSecondInsured',
              'medicalOsteoporosisSecondInsured',
              'medicalSystemicLupusSecondInsured',
              'medicalSclerodermaSecondInsured',
              'medicalRetinopathySecondInsured',
              'medicalLossOfVisionSecondInsured',
              'medicalWetMacularDegenerationSecondInsured',
              'medicalKaposiSarcomaSecondInsured',
              'medicalPneumocystisCariniiPneumoniaSecondInsured',
            ],
          },
        ],
      },
      {
        id: 'medical-conditions-b-spi-group-1',
        title: 'Medical History - During Past 2 Years',
        questionGroups: [
          {
            id: 'medical-conditions-b-spi-group-1',
            format: 'default',
            questions: [
              'medicalHospitalTreatmentSecondInsured',
              'medicalEmergencyRoomTreatmentSecondInsured',
              'medicalNursingHomeAdmissionSecondInsured',
              'medicalNursingHomeRecommendationSecondInsured',
              'medicalAssistanceBathingSecondInsured',
              'medicalAssistanceDressingSecondInsured',
              'medicalAssistanceWalkingSecondInsured',
              'medicalAssistanceEatingSecondInsured',
              'medicalAssistanceUsingToiletSecondInsured',
              'medicalAssistanceGettingUpSecondInsured',
              'medicalAssistanceTakingMedicationSecondInsured',
              'medicalAssistanceShoppingSecondInsured',
              'medicalAssistanceCookingSecondInsured',
              'medicalPendingDiagnosticTestSecondInsured',
              'medicalPendingHospitalizationSecondInsured',
              'medicalPendingSurgerySecondInsured',
              'medicalClaimInjurySecondInsured',
              'medicalClaimSicknessSecondInsured',
              'medicalClaimDisabilitySecondInsured',
              'medicalInjuryFromFallSecondInsured',
            ],
          },
        ],
      },
      {
        id: 'medical-conditions-c-spi-group-1',
        title: 'Current Medical Status',
        questionGroups: [
          {
            id: 'medical-conditions-c-spi-group-1',
            format: 'default',
            questions: [
              'medicalPhysicalTherapySecondInsured',
              'medicalOccupationalTherapySecondInsured',
              'medicalSpeechTherapySecondInsured',
              'medicalRespiratoryTherapySecondInsured',
              'medicalCaneUseSecondInsured',
              'medicalCrutchUseSecondInsured',
              'medicalWalkerUseSecondInsured',
              'medicalWheelchairUseSecondInsured',
              'medicalMotorizedScooterUseSecondInsured',
              'medicalMotorizedChairUseSecondInsured',
              'medicalStairLiftUseSecondInsured',
              'medicalHandicappedPlacardUseSecondInsured',
              'medicalCatheterUseSecondInsured',
              'medicalOxygenEquipmentUseSecondInsured',
              'medicalRespiratorUseSecondInsured',
              'medicalCpapUseSecondInsured',
              'medicalDefibrillatorUseSecondInsured',
              'medicalPacemakerUseSecondInsured',
              'medicalDialysisUseSecondInsured',
              'medicalUpcomingVisitSecondInsured',
              'medicalCurrentlyPregnantSecondInsured',
              'medicalPrimaryCarePhysicianSecondInsuredName',
              'medicalPrimaryCarePhysicianSecondInsuredAddress',
              'medicalMedicationsSecondInsured',
            ],
          },
        ],
      },
      {
        id: 'other-medical-spi',
        title: 'Medical Questionnaire - Other',
        questionGroups: [
          {
            id: 'driving-history-spi',
            title: 'Driving and Legal History',
            format: 'default',
            questions: [
              'medicalDrivingViolationSecondInsured',
              'medicalCriminalConvictionSecondInsured',
            ],
          },
          {
            id: 'insurance-status-spi',
            title: 'Insurance History',
            format: 'default',
            questions: [
              'medicalInsuranceDeclinedSecondInsured',
              'medicalSectionEDetailsSecondInsured',
            ],
          },
          {
            id: 'substance-history-spi',
            title: 'Substance Use History',
            format: 'default',
            questions: [
              'medicalNarcoticsUseSecondInsured',
              'medicalBarbituratesUseSecondInsured',
              'medicalAmphetaminesUseSecondInsured',
              'medicalHallucinogensUseSecondInsured',
              'medicalHeroinUseSecondInsured',
              'medicalCocaineUseSecondInsured',
              'medicalMarijuanaUseSecondInsured',
              'medicalAlcoholTreatmentSecondInsured',
              'medicalPrescribedMedicationTreatmentSecondInsured',
              'medicalNonPrescribedDrugsTreatmentSecondInsured',
            ],
          },
          {
            id: 'hazardous-activities-spi',
            title: 'Hazardous Activities',
            format: 'default',
            questions: [
              'medicalHazardousActivitiesSecondInsured',
              'medicalAviationSecondInsured',
              'medicalForeignTravelSecondInsured',
              'medicalArmedForcesSecondInsured',
            ],
          },
          {
            id: 'tobacco-nicotine-spi',
            title: 'Tobacco or Nicotine Use',
            format: 'default',
            questions: [
              'nicotineCigarettesUseSecondInsured',
              'nicotinePipeUseSecondInsured',
              'nicotineCigarsUseSecondInsured',
              'nicotineSnuffUseSecondInsured',
              'nicotineChewingTobaccoUseSecondInsured',
              'nicotinePatchUseSecondInsured',
              'nicotineGumUseSecondInsured',
              'nicotineVapingUseSecondInsured',
              'nicotineECigarettesUseSecondInsured',
              'nicotineHookahUseSecondInsured',
            ],
          },
        ],
      },
    ],
  },
};
